import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Pagination, PaginationRequest } from '../models/pagination.model';
import { Device } from '../models/device.model';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';
import * as utils from '../../shared/helpers/utils';

@Injectable({
  providedIn: 'root'
})
export class DeviceService {

  private currentDeviceConfig: any = {};
  constructor(
    private httpClient: HttpClient
  ) { }

  index(pagination: PaginationRequest): Observable<Pagination<Device>> {
    return this.httpClient.get<Pagination<Device>>(environment.apiUrl + '/devices', { params: utils.cleanParams(pagination) });
  }

  insert(device: Device): Observable<Device> {
    return this.httpClient.post<Device>(environment.apiUrl + '/devices', utils.cleanParams(device));
  }

  get(deviceId: number, packageType?: number): Observable<Device> {
    return this.httpClient.get<Device>(environment.apiUrl + `/devices/${deviceId}`);
  }

  update(device: Device): Observable<Device> {
    return this.httpClient.patch<Device>(environment.apiUrl + '/devices/' + device.id, utils.cleanParams(device));
  }

  destroy(id: number): Observable<Device> {
    return this.httpClient.delete<Device>(environment.apiUrl + '/devices/' + id);
  }

  getEntityDevices(entityId: number): Observable<Device[]> {
    return this.httpClient.get<Device[]>(environment.apiUrl + '/entities/' + entityId + '/devices');
  }
  //guardamos el estado de los filtros en el servicio
  setCurrentDeviceParamConfig(param: string, value: any) {
    this.currentDeviceConfig[param] = value;
  }

  getCurrentDeviceParamConfig(param: string): any {
    return this.currentDeviceConfig[param];
  }

  clearCurrentDeviceConfig() {
    this.currentDeviceConfig = {};
  }
}
